import fetchCommonData from "./fetchCommonData"
export default (() => {
    let onloads = [], data = []
    fetchCommonData().then(res => {
        data = res
        onloads.forEach(fn => {
            fn(res)
        })
        onloads.length = 0
    })
    return  {
        onload (call) {
            if (data.length > 0) {
                call(data)
            } else {
                onloads.push(call)
            }
        }
    }
}) ()